/** @format */
import Master from '../../Layouts/Master';
import ErrorMessage from '../../../Shared/Components/ErrorMessage';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import useApi from '../../../Shared/hooks/api/Index';
import { error, success } from '../../../Shared/Components/Toast';
import { useEffect } from 'react';
import { useContext } from 'react';
import { EventContext } from '../../../Contexts/EventContext';
import Select from 'react-select';
import { competitionLevels } from '../../../Shared/utils/helper';
import SwitchButton from '../../../Shared/Components/SwitchButton';
import Loading from '../../../Shared/Components/Loading';

const validationSchema = Yup.object().shape({
	title: Yup.string()
		.required('عنوان الزامی است')
		.max(190, 'عنوان نمیتواند بیشتر از 190 کاراکتر باشد'),
	allowed_person: Yup.number()
		.typeError('تعداد افراد مجاز نمی تواند خالی باشد.')
		.required('تعداد افراد مجاز نمی تواند خالی باشد.'),
	allowed_team: Yup.number()
		.typeError('تعداد  تیم مجاز نمی تواند خالی باشد.')
		.required('تعداد  تیم مجاز نمی تواند خالی باشد.'),
	allowed_team_person: Yup.number()
		.typeError('تعداد افراد تیم نمی تواند خالی باشد.')
		.required('تعداد افراد تیم نمی تواند خالی باشد.'),
	access_by: Yup.array()
		.typeError('دسترسی نمی تواند خالی باشد.')
		.required('دسترسی نمی تواند خالی باشد.'),
	match_kind: Yup.array()
		.typeError('نوع نمی تواند خالی باشد.')
		.required('نوع نمی تواند خالی باشد.'),
	sport_id: Yup.number()
		.typeError('رشته نمی تواند خالی باشد.')
		.required('رشته نمی تواند خالی باشد.'),
	register_by: Yup.number()
		.typeError('ثبت نام توسط نمی تواند خالی باشد.')
		.required('ثبت نام توسط نمی تواند خالی باشد.'),
	competition_level: Yup.number()
		.typeError('سطح برگزاری توسط نمی تواند خالی باشد.')
		.required('سطح برگزاری توسط نمی تواند خالی باشد.'),
	accept_by: Yup.number()
		.typeError(' تایید توسط نمی تواند خالی باشد.')
		.required(' تایید توسط نمی تواند خالی باشد.'),
	is_free: Yup.bool().typeError('فیلد رایگان الزامی است'),
	just_allowed_zone: Yup.bool().typeError('فیلد استان های مجاز الزامی است'),
	person_limit: Yup.bool().typeError(
		'فیلد محدودیت ظرفیت وابسته به استان الزامی است',
	),
});

const CreateMatchStyle = () => {
	const navigate = useNavigate();
	const [submitFormLoading, setSubmitFormLoading] = useState(false);
	const eventContext = useContext(EventContext);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		getInfo();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getInfo = async () => {
		setLoading(true);
		await useApi.get(
			'/panel/role?all=1',
			{},
			(res) => {
				eventContext.roles = res.data.data?.filter(
					(r) =>
						r.name === 'federation' ||
						r.name === 'zone' ||
						r.name === 'province board' ||
						r.name === 'user' ||
						r.name === 'club' ||
						r.name === 'committee',
				);
			},
			(err) => {
				console.log(err);
				error('هنگام دریافت اطلاعات خطایی رخ داده است.');
				setLoading(false);
			},
		);
		await useApi.get(
			'/panel/match-kind',
			{},
			(res) => {
				eventContext.matchKinds = res.data.data;
			},
			(err) => {
				console.log(err);
				error('هنگام دریافت اطلاعات خطایی رخ داده است.');
				setLoading(false);
			},
		);
		await useApi.get(
			'/panel/base/sport',
			{},
			(res) => {
				eventContext.sports = res.data.data;
				setLoading(false);
			},
			(err) => {
				console.log(err);
				error('هنگام دریافت اطلاعات خطایی رخ داده است.');
				setLoading(false);
			},
		);
	};

	const onSubmitForm = async (values, setSubmitting) => {
		setSubmitFormLoading(true);

		values['access_by'] = values?.access_by?.map((a) => a.id);
		values['match_kind'] = values?.match_kind?.map((m) => m.id);
		values['is_free'] = values?.is_free === true ? 1 : 0;
		values['just_allowed_zone'] = values?.just_allowed_zone === true ? 1 : 0;
		values['person_limit'] = values?.person_limit === true ? 1 : 0;
		values['accept_by'] = parseInt(values.accept_by);
		values['competition_level'] = parseInt(values.competition_level);
		values['register_by'] = parseInt(values.register_by);
		values['sport_id'] = parseInt(values.sport_id);

		await useApi.post(
			'/panel/base/match-style',
			values,
			(res) => {
				success('سبک مسابقات با موفقیت ایجاد شد');
				navigate('/panel/base-define/match-style', { replace: true });
			},
			(err) => {
				setSubmitFormLoading(false);
				error('خطایی در ثبت اطلاعات پیش آمده است.');
			},
		);
	};

	return loading ? (
		<Loading />
	) : (
		<Master>
			<Formik
				initialValues={{
					title: '',
					allowed_person: '',
					allowed_team: '',
					allowed_team_person: '',
					access_by: '',
					match_kind: '',
					sport_id: '',
					register_by: '',
					competition_level: '',
					accept_by: '',
					is_free: '',
					just_allowed_zone: '',
					person_limit: '',
				}}
				onSubmit={(values, { setSubmitting }) => {
					onSubmitForm(values, setSubmitting);
				}}
				validationSchema={validationSchema}>
				{({
					values,
					errors,
					handleChange,
					handleSubmit,
					isSubmitting,
					setFieldValue,
				}) => (
					<form onSubmit={handleSubmit}>
						<div className='row border rounded mt-3'>
							<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>عنوان سبک مسابقات</label>
										<input
											name='title'
											value={values.title}
											onChange={handleChange}
											type='text'
											className='form-control'
										/>
										<ErrorMessage error={errors.title} />
									</div>
								</div>
							</div>
							<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>تعداد افراد مجاز</label>
										<input
											name='allowed_person'
											value={values.allowed_person}
											onChange={handleChange}
											type='number'
											className='form-control'
										/>
										<ErrorMessage error={errors.allowed_person} />
									</div>
								</div>
							</div>
							<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>تعداد تیم مجاز </label>
										<input
											name='allowed_team'
											value={values.allowed_team}
											onChange={handleChange}
											type='number'
											className='form-control'
										/>
										<ErrorMessage error={errors.allowed_team} />
									</div>
								</div>
							</div>
							<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
								<div className='form-group'>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>تعداد افراد تیم</label>
										<input
											name='allowed_team_person'
											value={values.allowed_team_person}
											onChange={handleChange}
											type='number'
											className='form-control'
										/>
										<ErrorMessage error={errors.allowed_team_person} />
									</div>
								</div>
							</div>
							{eventContext?.roles?.length > 0 && (
								<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
									<div className='form-group'>
										<div className='d-flex flex-column mt-1 mx-2'>
											<label>دسترسی</label>
											<Select
												isMulti
												closeMenuOnSelect={false}
												options={eventContext.roles?.filter(
													(r) => r.name !== 'committee' && r.name !== 'user',
												)}
												onChange={(value) => {
													setFieldValue('access_by', value, true);
												}}
												noOptionsMessage={() => 'لطفا دسترسی ها را انتخاب کنید'}
												getOptionLabel={(c) => c.description}
												getOptionValue={(c) => c.id}
												className='w-100'
												placeholder='انتخاب کنید...'
											/>

											<ErrorMessage error={errors.access_by} />
										</div>
									</div>
								</div>
							)}

							{eventContext?.matchKinds?.length > 0 && (
								<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
									<div className='form-group'>
										<div className='d-flex flex-column mt-1 mx-2'>
											<label>نوع</label>
											<Select
												isMulti
												closeMenuOnSelect={false}
												options={eventContext.matchKinds}
												onChange={(value) =>
													setFieldValue('match_kind', value, true)
												}
												noOptionsMessage={() => 'لطفا  نوع را انتخاب کنید'}
												getOptionLabel={(c) => c.name}
												getOptionValue={(c) => c.id}
												className='w-100'
												placeholder='انتخاب کنید...'
											/>

											<ErrorMessage error={errors.match_kind} />
										</div>
									</div>
								</div>
							)}
							{eventContext?.sports?.length > 0 && (
								<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
									<div className='form-group'>
										<div className='d-flex flex-column mt-1 mx-2'>
											<label>رشته ورزشی</label>
											<select
												className='form-control'
												name='sport_id'
												onChange={handleChange}
												value={values.sport_id}>
												<option>انتخاب کنید</option>
												{eventContext.sports.map((item) => (
													<option value={item.id}>{item.name_fa}</option>
												))}
											</select>
											<ErrorMessage error={errors.sport_id} />
										</div>
									</div>
								</div>
							)}
							{eventContext?.roles?.length > 0 && (
								<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
									<div className='form-group'>
										<div className='d-flex flex-column mt-1 mx-2'>
											<label>ثبت نام توسط</label>
											<select
												className='form-control'
												name='register_by'
												onChange={handleChange}
												value={values.register_by}>
												<option>انتخاب کنید</option>
												{eventContext.roles
													?.filter((r) => r.name !== 'committee')
													?.map((item) => (
														<option value={item.id}>{item.description}</option>
													))}
											</select>
											<ErrorMessage error={errors.register_by} />
										</div>
									</div>
								</div>
							)}
							{competitionLevels()?.length > 0 && (
								<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
									<div className='form-group'>
										<div className='d-flex flex-column mt-1 mx-2'>
											<label>سطح برگزاری</label>
											<select
												className='form-control'
												name='competition_level'
												onChange={handleChange}
												value={values.competition_level}>
												<option>انتخاب کنید</option>
												{competitionLevels().map((item) => (
													<option value={item.id}>{item.name}</option>
												))}
											</select>
											<ErrorMessage error={errors.competition_level} />
										</div>
									</div>
								</div>
							)}
							{eventContext?.roles?.length > 0 && (
								<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
									<div className='form-group'>
										<div className='d-flex flex-column mt-1 mx-2'>
											<label>تایید توسط</label>
											<select
												className='form-control'
												name='accept_by'
												onChange={handleChange}
												value={values.accept_by}>
												<option>انتخاب کنید</option>
												<option value='0'>تعریف کننده</option>
												{eventContext.roles
													?.filter((r) => r.name !== 'user' && r.name !== 'club')
													?.map((item) => (
														<option value={item.id}>{item.description}</option>
													))}
											</select>
											<ErrorMessage error={errors.accept_by} />
										</div>
									</div>
								</div>
							)}
							<div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
								<div className='form-group'>
									<div className='d-flex flex-row mt-1 mx-2'>
										<label>رایگان</label>
										<SwitchButton
											classes='mx-3'
											checked={values.is_free}
											onChange={(val) => {
												setFieldValue('is_free', val, true);
											}}
										/>
										<ErrorMessage error={errors.is_free} />
									</div>
								</div>
							</div>
							<div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
								<div className='form-group'>
									<div className='d-flex flex-row mt-1 mx-2'>
										<label>انتخاب استان های مجاز</label>
										<SwitchButton
											classes='mx-3'
											checked={values.just_allowed_zone}
											onChange={(val) => {
												setFieldValue('just_allowed_zone', val, true);
											}}
										/>
										<ErrorMessage error={errors.just_allowed_zone} />
									</div>
								</div>
							</div>
							<div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
								<div className='form-group'>
									<div className='d-flex flex-row mt-1 mx-2'>
										<label>محدودیت ظرفیت وابسته به استان </label>
										<SwitchButton
											classes='mx-3'
											checked={values.person_limit}
											onChange={(val) => {
												setFieldValue('person_limit', val, true);
											}}
										/>
										<ErrorMessage error={errors.person_limit} />
									</div>
								</div>
							</div>
							<div className='col-12'>
								<div className='d-flex flex-row justify-content-end my-3'>
									<button className='btn btn-info btn-sm f-14'>
										{submitFormLoading ? (
											<div
												className='spinner-border spinner-border-sm text-white mb-1'
												role='status'></div>
										) : (
											'ثبت سبک مسابقات'
										)}
									</button>
								</div>
							</div>
						</div>
					</form>
				)}
			</Formik>
		</Master>
	);
};

export default CreateMatchStyle;
